import CandidatesList from './CandidatesList';

export default CandidatesList;
